module.exports = __webpack_public_path__ + "img/doc-ad2-xs.d7ec6ac3.jpg";